module.exports = __webpack_public_path__ + "img/20_106.c74d6453.png";